import CustomerRecordWidget from "./CustomerRecordWidget";

class CustomerRecordWidgets {
  constructor(private readonly _list: CustomerRecordWidget[] = []) {
  }

  public isEmpty(): boolean {
    return this._list ? this._list.length <= 0 : true;
  }

  public has(index: number): boolean {
    return !!this._list[index];
  }

  public toList(): CustomerRecordWidget[] {
    return this._list;
  }

  public findByIndex(index: number): CustomerRecordWidget {
    if (this.isEmpty() || !this.has(index)) return new CustomerRecordWidget();
    return this._list[index];
  }

  public replace(index: number, widget: CustomerRecordWidget): CustomerRecordWidgets {
    if (this.isEmpty() || !this.has(index)) return new CustomerRecordWidgets();
    this._list[index] = widget;
    return new CustomerRecordWidgets(this._list);
  }

  public add(widget: CustomerRecordWidget): CustomerRecordWidgets {
    this._list.push(widget);
    return new CustomerRecordWidgets(this._list);
  }

  public delete(index: number): CustomerRecordWidgets {
    if (this.isEmpty() || !this.has(index)) return new CustomerRecordWidgets(this._list);
    this._list.splice(index, 1);
    return new CustomerRecordWidgets(this._list);
  }

  public size(): number {
    return this._list.length;
  }
}

export default CustomerRecordWidgets;
